import isDateStringToday from '@afosto/utils-react/date/isDateStringToday';

export default (operator, values = []) => {
  if (values?.length === 1) {
    const [firstValue] = values;
    return isDateStringToday(firstValue, operator);
  }

  if (values?.length === 2) {
    return isDateStringToday(values[0], 'gte') && isDateStringToday(values[1], 'gt');
  }

  return false;
};
